import React, { Fragment, useState, useRef, useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from '../../../../../constants/areas';
import { getInt } from '../../../../../utils/functions';
import { withAreaGetter } from 'providers/AreasConsumers';

import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import RefineAuthorizationListBrowser from './RefineAuthorizationListBrowser';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const RefineAuthorizationRoute = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const authorizationId = getInt(match.params.authorizationId);
  const [title, setTitle] = useState('');
  const stateRef = useRef({
    onSave: () => {}
  });

  const setStateRef = (prop, value) => {
    stateRef.current = {
      ...stateRef.current,
      [prop]: value
    };
  };

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setStateRef('onSave', fn);
    const { onDisabledSaveChange } = stateRef.current;
    onDisabledSaveChange && onDisabledSaveChange(disabledSave);
  }, []);

  const onClose = useCallback(() => {
    historyContext.push('/security');
  }, [historyContext]);

  const onChangedTitle = useCallback(name => {
    setTitle(name);
  }, []);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClose={onClose} stateRef={stateRef} />
      </Portal>
      <RefineAuthorizationListBrowser authorizationId={authorizationId} onSaveFnChanged={onSaveFnChanged} onChangedTitle={onChangedTitle} />
    </Fragment>
  );
};

RefineAuthorizationRoute.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(RefineAuthorizationRoute);
